import Controller from "./stats.controller";
import template from "./stats.html";

const stats = {
  template,
  controller: Controller,
};

export default stats;



// WEBPACK FOOTER //
// ./src/pages/stats/stats.component.js